import HowToStart from './HowToStart';
export default HowToStart;
